import React from 'react';

import type { GmailInvitePreview } from '../services/gmailInviteService';
import { maskEmail, recordingBlur } from '../utils/recordingBlur';

/** The invitation as the person will read it, drawn in the app's own style (no raw email HTML). */
export const InviteEmailCard: React.FC<{ preview: GmailInvitePreview | null; to?: string }> = ({ preview, to }) => {
  if (!preview?.parts) {
    return <div aria-busy="true" className="invite-email invite-email--loading">Loading the email…</div>;
  }
  const { parts } = preview;
  const recipient = to ?? preview.to;
  const shownTo = recipient && recordingBlur() ? maskEmail(recipient) : recipient;

  return (
    <article aria-label="The invitation email" className="invite-email">
      <dl className="invite-email__head">
        <div><dt>From</dt><dd>{preview.from}</dd></div>
        <div><dt>To</dt><dd>{shownTo ?? 'Each person you pick, by name'}</dd></div>
        <div><dt>Subject</dt><dd>{preview.subject}</dd></div>
      </dl>
      <div className="invite-email__body">
        <p>{parts.greeting}</p>
        <p>{parts.pitch}</p>
        <span className="invite-email__button">{parts.button}</span>
        <p>{parts.signature}</p>
        <p className="invite-email__footer">{parts.footer.join(' ')} Each email has an unsubscribe link.</p>
      </div>
    </article>
  );
};
